import React from 'react';

/**
 * Ловит ошибки рендера, чтобы белый экран не ронял всё приложение.
 * Логирует в консоль и, если подключён Sentry (window.Sentry), отправляет туда.
 * Полноценный Sentry подключается опционально: npm i @sentry/react и init по
 * REACT_APP_SENTRY_DSN (см. frontend/env.example.txt).
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info);
    try {
      if (window.Sentry?.captureException) {
        window.Sentry.captureException(error, { extra: info });
      }
    } catch (_) {}
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center px-4 text-center">
          <div className="max-w-md">
            <h1 className="text-2xl font-bold mb-2">Что-то пошло не так</h1>
            <p className="text-muted-foreground mb-6">
              Мы уже знаем о проблеме. Попробуйте обновить страницу.
            </p>
            <button
              onClick={this.handleReload}
              className="rounded-full px-6 py-3 bg-primary text-primary-foreground font-medium"
            >
              Обновить страницу
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
